/*
 * Copyright (c) 2026. BrightNight. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */

export function captureWindowRects() {
  const rects = new Map<string, DOMRect>();
  for (const frame of document.querySelectorAll<HTMLElement>('[data-desktop-window]')) {
    const name = getComputedStyle(frame).viewTransitionName;
    if (!name || name === 'none') continue;
    const rect = frame.getBoundingClientRect();
    if (rect.width > 0 && rect.height > 0) rects.set(name, rect);
  }
  return rects;
}

/** The browser's default snapshot-group animation interpolates width/height on the main
 * thread. Hold the group at its final size and move/scale its picture on the compositor.
 */
export function animateWindowSnapshots(before: Map<string, DOMRect>, after: Map<string, DOMRect>) {
  for (const [name, to] of after) {
    const from = before.get(name);
    if (!from) continue;
    if (from.x === to.x && from.y === to.y && from.width === to.width && from.height === to.height)
      continue;
    document.documentElement.animate(
      [
        {
          transform: `translate(${from.x}px, ${from.y}px) scale(${from.width / to.width}, ${from.height / to.height})`,
          transformOrigin: '0 0',
        },
        { transform: `translate(${to.x}px, ${to.y}px) scale(1)`, transformOrigin: '0 0' },
      ],
      {
        duration: 180,
        easing: 'cubic-bezier(0.25, 0.1, 0.25, 1)',
        pseudoElement: `::view-transition-group(${name})`,
      },
    );
  }
}
